import React from 'react'
import { PopupCloseButtonUi } from './popup-close-ui'

interface PopupCloseProps {
  onClose?: () => void
  color?: string
  mobileColor?: string
}

export const PopupClose = ({
  onClose,
  color,
  mobileColor,
}: PopupCloseProps) => {
  return (
    <PopupCloseButtonUi
      backgroundColor={color}
      mobileBackgroundColor={mobileColor}
      onClick={e => {
        e.preventDefault()
        onClose?.()
      }}
    />
  )
}
